<template>
    <vs-popup :title="(roleName) +' Rolü İçin Rol Yetkilendirme Tablosu'"  :active.sync="isSidebarActiveLocal">
        <div id="data-list-thumb-view" class="data-list-container">
          <vs-input v-model="filterText" type="text" placeholder="Filtrele"/>
            <vs-table
        ref="table"
        :data="filteredItems">
        <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
      </div>
        <template slot="thead">
          <vs-th class="w-3/12 justify-center">
            <vs-button
              icon-pack="feather"
              color="primary"
              type="flat"
              >Rol İsmi
            </vs-button>
          </vs-th>
         
          <vs-th class="w-1/12">
            <vs-button
              color="primary"
              class="opacity-full"
              disabled="true"
              type="flat"
              >İşlem</vs-button
            >
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody class="text-center">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="w-3/12">
                <p class="font-medium truncate">{{ tr.permissionName }}</p>
              </vs-td>
  
              <vs-td vs-align="center"
                class="whitespace-no-wrap w-1/12"
              >
              <vs-switch @click="switchChanged(tr)" class="ml-6" v-model="tr.hasAuthority">
                <span slot="on">Aktif</span>
                <span slot="off">Pasif</span>
              </vs-switch>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
        </div>
    </vs-popup>
</template>

<script>
import { addPermission,deletePermission } from "@/api/Role.js";
export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Array,
        default: () => []
      },
      roleName:{
        type: String,
        default: () => ''
      }
    },
    data(){
        return {
            localArray:[],
            filterText:''
        }
    },
    methods:{
      switchChanged: async function (tr) {
        console.log(tr);
        console.log(tr.hasAuthority);
        if (!tr.hasAuthority) {
          await addPermission({roleId:tr.roleId,permissionId:tr.permissionId})
        }else{
          await deletePermission({roleId:tr.roleId,permissionId:tr.permissionId})
        }
      // Anahtar değiştirici durumu değiştiğinde bu method çağrılır

      // Burada başka işlemler yapabilirsiniz
    }
    },
    computed: {
      filteredItems() {
    return this.localArray.filter(item => {
      return item.permissionName.toLocaleLowerCase('tr-TR').includes(this.filterText.toLocaleLowerCase('tr-TR'));
    });
  },
        isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeSidebar");
            //this.$validator.reset();
            //this.initValues();
          }
        }
      }
    },
    watch:{
        isSidebarActive: function (val) {
            if (val) {
                this.localArray = _.cloneDeep(this.data);
                this.filterText ='';
            }
        }
    }
}
</script>